import {
  EdgeStyleIndicatorRenderer,
  HighlightIndicatorManager,
  IEdge,
  INode,
  IObjectRenderer,
  NodeStyleIndicatorRenderer,
  StyleIndicatorZoomPolicy,
} from '@ardoq/yfiles';
import { HoverEdgeStyle } from 'yfilesExtensions/view/modernized/HoverEdgeStyle';
import { DropzoneNodeStyle } from '../DropzoneNodeStyle';
import type { DropzoneHighlightStateHolder } from '../dropzoneHighlightState';

class ModernizedHighlightIndicatorManager extends HighlightIndicatorManager<
  INode | IEdge
> {
  private readonly nodeHighlightRenderer: NodeStyleIndicatorRenderer;
  private readonly edgeHighlightRenderer = new EdgeStyleIndicatorRenderer({
    edgeStyle: new HoverEdgeStyle(),
    zoomPolicy: StyleIndicatorZoomPolicy.WORLD_COORDINATES,
  });

  constructor(dropzoneState: DropzoneHighlightStateHolder) {
    super();
    this.nodeHighlightRenderer = new NodeStyleIndicatorRenderer({
      nodeStyle: new DropzoneNodeStyle(dropzoneState),
      margins: DropzoneNodeStyle.MARGIN,
      zoomPolicy: StyleIndicatorZoomPolicy.WORLD_COORDINATES,
    });
  }

  protected override getRenderer(
    item: INode | IEdge
  ): IObjectRenderer<INode | IEdge> | null {
    if (item instanceof INode) {
      return this.nodeHighlightRenderer;
    }
    if (item instanceof IEdge) {
      return this.edgeHighlightRenderer;
    }
    return super.getRenderer(item);
  }
}
export { ModernizedHighlightIndicatorManager };
